import React from 'react';
import SiteFooter from '../components/common/SiteFooter';
import './Legal.css';

const Privacy: React.FC = () => {
  return (
    <div className="legal-page">
      <main className="legal-card" aria-labelledby="privacy-title">
        <header className="legal-card__header" data-tour="legal-header">
          <h1 id="privacy-title">Privacy Policy</h1>
          <p>Last updated: March 24, 2026</p>
        </header>

        <div className="legal-card__content" data-tour="legal-content">
          <section>
            <h2>Overview</h2>
            <p>
              iKompete is operated by Data Science Research Services (DSRS) at the University of Illinois
              Urbana-Champaign. This page summarizes how platform data is collected, used, and protected.
            </p>
          </section>

          <section>
            <h2>Information We Collect</h2>
            <ul>
              <li>Account data such as username, name, and University email address.</li>
              <li>Competition participation data, including submissions, votes, and rankings.</li>
              <li>Operational logs needed for security, troubleshooting, and service reliability.</li>
            </ul>
          </section>

          <section>
            <h2>How Information Is Used</h2>
            <ul>
              <li>To authenticate users and manage access to competitions.</li>
              <li>To administer competitions, judging, scoring, and leaderboards.</li>
              <li>To improve platform quality, resolve incidents, and maintain security.</li>
            </ul>
          </section>

          <section>
            <h2>Data Sharing</h2>
            <p>
              Data is shared only as needed to operate the platform, comply with applicable University policy,
              and meet legal obligations. Public competition views may display limited profile or ranking
              information based on competition settings.
            </p>
          </section>

          <section>
            <h2>Storage and Security</h2>
            <p>
              Reasonable administrative and technical safeguards are used to protect stored information.
              Submission files and metadata are retained according to platform and institutional needs.
            </p>
          </section>

          <section>
            <h2>Your Choices</h2>
            <p>
              You may request profile updates or account support by contacting DSRS.
              Competition-specific visibility settings may control what other users can see.
            </p>
          </section>

          <section>
            <h2>Contact</h2>
            <p>
              For privacy questions, contact <a href="mailto:dsrs@business.illinois.edu">dsrs@business.illinois.edu</a>.
            </p>
          </section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default Privacy;

